const TokenKey = 'x-token'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token, refresh_token) {
  if (refresh_token) {
    // 用于重新登录时的刷新令牌
    localStorage.setItem('x-refresh-token', refresh_token)
  }
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}
